<template>
  <div class="bid-file-preview-balance">
    <!-- 标书预览余额 -->
    <div class="preview-card">
      <div class="preview-card-header">
        <div class="preview-card-header__title">标书预览余额</div>
        <div class="preview-card-header__tip">
          线上自助充值所购买的标书预览次数从购买时间节点起有效期限为1年，详细服务请联系客服
          {{ consumerHotline }}
        </div>
      </div>
      <div class="preview-card-body">
        <!-- 标书预览余额 -->
        <div class="preview-section">
          <div class="preview-section-header font-color-main m-b-8">
            标书预览余额
          </div>
          <div class="preview-section-body flex row-between ">
            <div class="font-color-main text-bold">
              <span class="font-24 m-r-6">
                {{ bidFilePreviewBalance.remain || 0 }}
              </span>
              次
            </div>
            <div class="flex col-center">
              <el-button
                type="text"
                @click="openPayHistory"
              >充值记录</el-button>
              <el-button
                type="primary"
                size="small"
                @click="buyPreviewBalance"
              >立即充值</el-button>
            </div>
          </div>
        </div>
        <!-- 即将到期余额 -->
        <div class="preview-section">
          <div class="preview-section-header font-color-main m-b-8">
            即将到期余额
            <el-tooltip
              class="item"
              effect="dark"
              popper-class="my_popper"
              placement="top"
            >
              <div slot="content" class="slot-content">
                套餐有效期小于或等于30天则视为即将到期，<br />请在到期前尽快使用。
              </div>
              <i class="iconfont icon-help text-cursor m-r-5"></i>
            </el-tooltip>
          </div>
          <div class="preview-section-body">
            <div class="font-color-main text-bold">
              <span class="font-20 font-color-warning m-r-6">
                {{ bidFilePreviewBalance.willExpire || 0 }}
              </span>
              次
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 充值记录 -->
    <el-dialog
      title="充值记录"
      :visible.sync="payHistoryDialogVisible"
      width="50%"
      class="dialog"
    >
      <jczh-table-content
        :data="payHistoryList"
        :option="payHistoryListOption"
        pagination
        :page.sync="payHistoryPage"
        :size.sync="payHistorySize"
        :total="payHistoryTotal"
        @pagination="getPayHistoryList"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  queryValueAddedServiceAccountBalanceApi,
  queryValueAddedServicePayHistoryApi
} from '@/api/value-added-service'
import { valueAddedProductCodeDict } from '@/dictionary/value-added-service'
import { mapState } from 'vuex'

/**
 * @description: 招标文件预览-余额
 */
export default {
  name: 'BidFilePreviewBalance',

  data() {
    return {
      // 标书余额信息
      bidFilePreviewBalance: {
        // 标书预览余额
        remain: 0,
        // 即将到期余额
        willExpire: 0
      },

      // 充值记录弹窗
      payHistoryDialogVisible: false,
      // 充值记录列表
      payHistoryList: [],
      payHistoryListOption: [
        { label: '流水号', prop: 'payInfo', filter: value => value.payCode },
        { label: '充值时间', prop: 'payInfo', filter: value => value.payTime },
        { label: '充值次数', prop: 'orderItem', filter: value => value.number }
      ],
      payHistoryPage: 1,
      payHistorySize: 10,
      payHistoryTotal: 0
    }
  },

  created() {
    this.getBidFilePreviewBalance()
  },

  computed: {
    ...mapState('system', ['consumerHotline'])
  },

  methods: {
    /**
     * 查询标书预览服务余额
     */
    getBidFilePreviewBalance() {
      queryValueAddedServiceAccountBalanceApi(
        valueAddedProductCodeDict.BID_FILE_PREVIEW.value
      )
        .then(res => {
          this.bidFilePreviewBalance = res.data || {
            remain: 0,
            willExpire: 0
          }
        })
        .catch(err => {
          console.error('获取标书预览服务余额失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 购买标书预览流量包
     */
    buyPreviewBalance() {
      const url =
        process.env.VUE_APP_PORTAL_URL + '/value-added/bid-file-preview/buy'
      window.open(url, '_self')
    },

    /**
     * 打开充值记录弹窗
     */
    openPayHistory() {
      this.payHistoryDialogVisible = true
      this.getPayHistoryList()
    },

    /**
     * 获取充值记录
     */
    getPayHistoryList() {
      const requestParams = {
        page: this.payHistoryPage,
        size: this.payHistorySize,
        productCode: valueAddedProductCodeDict.BID_FILE_PREVIEW.value
      }
      queryValueAddedServicePayHistoryApi(requestParams)
        .then(res => {
          this.payHistoryList = res.data?.records || []
          this.payHistoryTotal = res.data?.total || 0
        })
        .catch(err => {
          console.error('获取充值记录失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-file-preview-balance {
  .preview-card {
    width: 100%;
    border-radius: 4px;
    background: $white-color;
    padding: 24px;

    .preview-card-header {
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      .preview-card-header__title {
        font-size: 16px;
        color: $text-color;
        @include text-bold;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: $primary-color;
          margin-right: 6px;
          vertical-align: -12%;
        }
      }

      .preview-card-header__tip {
        font-size: 12px;
        color: $text-second-color;
        margin-left: 10px;
      }
    }

    .preview-card-body {
      display: flex;
      align-items: center;

      .preview-section {
        height: 88px;
        flex: 1;
        background: $info-fifth-color;
        border-radius: 4px;
        padding: 16px 24px;
        &:not(:last-child) {
          margin-right: 24px;
        }
      }
    }
  }
}

.icon-help {
  font-size: 20px;
  margin-left: 5px;
  color: $info-second-color;
  cursor: pointer;
}
</style>
